export const getDefaultValues = (gameDetails) => ({
  GameName: gameDetails?.GameName || '',
  GameNameEn: gameDetails?.GameNameEn || '',
  GameURL: gameDetails?.GameURL || '',
  GameUrlEn: gameDetails?.GameURLEn || '',
  GameDesc: gameDetails?.GameDescription || '',
  GameDescEn: gameDetails?.GameDescriptionEn || '',
  GameLogo: gameDetails?.GameLogo || '',
  GameTitleButton: gameDetails?.GameTitleButton || '',
  GameBackDrop: gameDetails?.GameBacDrop || '',
  GameSize: gameDetails?.GameSize || '',
  GameVersion: gameDetails?.GameVersion || '',
  GameAvrageRate: gameDetails?.GameAvrageRate || '',
  GameDesignMode: gameDetails?.GameDesignModeID || '',
  GameOrientationID: gameDetails?.GameOrientationID || '',
  IsWeb: !!gameDetails?.GameIsWebSupport ? true : false,
  IsMobile: !!gameDetails?.GameIsMobileSupport ? true : false,
});
